import { createAction } from '@reduxjs/toolkit';

export const asyncSubmitRecipients = createAction('[RequestShare] asyncSubmitRecipients');
export const asyncSubmitRecipientsResult = createAction('[RequestShare] asyncSubmitRecipientsResult');
